import HTTP from "@/_helpers/http";
import { TRANSACTIONS__API } from "@/_helpers/urls";
import { TRANSACTIONS__MUTATIONS } from "../mutation-types";
import { TRANSACTIONS__ACTIONS } from "../action-types";

// State
const state = {
  summaries: [],
  summariesExcel: [],
  paymentMethods: [],
  isLoading: false,
  range: null,
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1
  }
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [TRANSACTIONS__MUTATIONS.TRXSUMMARIES](state, data) {
    state.summaries = data.data.summaries;
    state.paymentMethods = data.data.paymentMethods;
    state.pagination = data.data.pagination;
    state.range = data.data.range || null;
  },

  [TRANSACTIONS__MUTATIONS.TRXSUMMARIESEXCEL](state, data) {
    state.summariesExcel = data.data.summariesExcel;
  },

  SET_LOADING(state, data) {
    state.isLoading = data;
  },
};

// Actions
const actions = {
  async [TRANSACTIONS__ACTIONS.TRXSUMMARIES]({ commit, state }, parameter = {}) {
    try {
      commit("SET_LOADING", true);

      const {
        method_name,
        testData,
        duration,
        page = 1,
        limit = 10,
        search = ""
      } = parameter;

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(method_name && { method_name }),
        ...(testData && { testData }),
        ...(duration && { duration }),
        ...(search && { search })
      }).toString();

      const response = await HTTP().get(
        `${TRANSACTIONS__API.TRXSUMMARIES}${queryParams ? `?${queryParams}` : ''}`
      );

      if (response.data.success) {
        commit(TRANSACTIONS__MUTATIONS.TRXSUMMARIES, response.data);
      }

    } catch (error) {
      console.log(error);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async [TRANSACTIONS__ACTIONS.TRXSUMMARIESEXCEL]({ commit, state }, parameter = {}) {
    try {
      const {
        method_name,
        duration,
        testData,
        page = 1,
        limit = 10,
        search = ""
      } = parameter;

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(method_name && { method_name }),
        ...(testData && { testData }),
        ...(duration && { duration }),
        ...(search && { search })
      }).toString();

      const response = await HTTP().get(
        `${TRANSACTIONS__API.TRXSUMMARIESEXCEL}${queryParams ? `?${queryParams}` : ''}`
      );

      if (response.data.success) {
        commit(TRANSACTIONS__MUTATIONS.TRXSUMMARIESEXCEL, response.data);
      }

    } catch (error) {
      console.log(error);
    } 
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};